import React, { useState, useEffect } from 'react';
import "./SectionThree.scss";
import { Description, GreenSubDescription, PaymentPendingHeading } from '../../../../../Global/GlobalText';
import { CheckboxInput, InputLabel, SelectBorder } from '../../../../../Global/GlobalFormElement';
import { GreyBorderButton, RedBackgroundButton } from '../../../../../Global/GlobalButton';
import { EXCHNAGE_URL } from '../../../../../../Url/Url';
import { useSelector } from 'react-redux';
import axios from 'axios';
import styled from 'styled-components';
export const ForJudgeSectionThree = ({ setSelectedButton, handleCheckboxChange, selectedRounds, selectedRoundId,setSelectedCategories,selectedCategories,setSelectedJudges, selectedJudges, setSelectedTopScore, selectedTopScore }) => {

    const [rounds, setRounds] = useState([]);
    const [categories, setCategories] = useState([]);
    const [judges, setJudges] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    // const [selectedCategories, setSelectedCategories] = useState([]);
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);

    const [selectedJudgesCategory, setSelectedJudgesCategory] = useState(""); // for radio toggle
    // const [selectedJudges, setSelectedJudges] = useState([]);
    const [showJudgeDropdown, setShowJudgeDropdown] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("newest");
    const [isLoading, setIsLoading] = useState(false);

    const eventIdGet = useSelector((state) => state?.users?.id || "");
    const eventId = String(eventIdGet);
    const token = localStorage.getItem("token")
    useEffect(() => {
        const fetchRounds = async () => {
            try {
                const token = localStorage.getItem('token');

                const response = await fetch(`${EXCHNAGE_URL}/listOfRounds?eventId=${eventId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }
                });
                const result = await response.json();
                if (result.status) {
                    setRounds(result.data);
                } else {
                    console.error('Failed to fetch rounds:', result.message);
                }
            } catch (error) {
                console.error('Error fetching rounds:', error);
            }
        };

        fetchRounds();
    }, []);


    useEffect(() => {
        if (selectedRoundId) {
            const fetchAllJuryAssignment = async () => {
                try {
                    const response = await axios.get(`${EXCHNAGE_URL}/allAssignJury?eventId=${eventId}&roundId=${selectedRoundId}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    const allJuryData = response.data.data;
                    setJudges(allJuryData);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchAllJuryAssignment();
        }
    }, [selectedRoundId, eventId, token]);


    console.log(judges, "judges")


    const getCategories = async () => {
        setIsLoading(true)
        try {
            let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${eventId}&sortOrder=${sortOrder}`;
            if (searchTerm) {
                apiUrl += `&search=${searchTerm}`;
            }
            const response = await axios.get(apiUrl, {
                headers: {
                    "Content-Type": "Application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (response.status === 200) {
                setCategories(response.data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getCategories();
    }, [eventId, searchTerm, sortOrder]);


    const handleNextClick = () => {
        setSelectedButton(4);
    };

    console.log(selectedCategories,"selecteddddddd")

    return (
        <div>
            <div className="section_one_three">
                <GreenSubDescription>Please Select Report Format</GreenSubDescription>

                <div className="section_three_radio">
                    <PaymentPendingHeading>Please select Score Option
                    </PaymentPendingHeading>
                </div>
                <StyledRoundCheckboxContainer>
                    {rounds.map((round) => (
                        <RoundItem key={round.roundId}>
                            <CheckboxInput
                                type="checkbox"
                                checked={selectedRoundId === round.roundId}
                                onChange={() => handleCheckboxChange(round.roundId)}
                            />
                            <span>{round.round_name}</span>
                        </RoundItem>
                    ))}
                </StyledRoundCheckboxContainer>

                <div className="section_three_radio">
                    <PaymentPendingHeading>Select Category</PaymentPendingHeading>
                </div>
                <div className="section_three_check">
                    <RadioOption>
                        <RadioInput
                            type="radio"
                            name="category"
                            value="All"
                            checked={selectedCategory === 'All'}
                            onChange={() => {
                                setSelectedCategory('All');
                                setSelectedCategories(categories.map(cat => cat.awardId));
                              }}
                        />
                        <span>All</span>
                    </RadioOption>
                    <RadioOption>
                        <RadioInput
                            type="radio"
                            name="category"
                            value="Custom"
                            checked={selectedCategory === 'Custom'}
                            onChange={() => {
                                setSelectedCategory('Custom');
                                setSelectedCategories([]);
                              }}
                        />
                        <span>Custom</span>
                    </RadioOption>
                </div>
                {selectedCategory === "Custom" && (
                    <div style={{ position: "relative", width: "400px" }}>
                        <CustomInput
                            type="text"
                            placeholder="Select custom category..."
                            onFocus={() => setShowCategoryDropdown(true)}
                            onBlur={() => setTimeout(() => setShowCategoryDropdown(false), 200)}
                        />

                        <SelectedOptionsContainer>
                            {selectedCategories.map((id) => {
                                const category = categories.find(cat => cat.awardId === id);
                                return (
                                    <OptionPill key={id}>
                                        {category?.category_name || id}
                                        <RemoveIcon
                                            onClick={() =>
                                                setSelectedCategories(prev => prev.filter(opt => opt !== id))
                                            }
                                        >
                                            ×
                                        </RemoveIcon>
                                    </OptionPill>
                                );
                            })}
                        </SelectedOptionsContainer>

                        {showCategoryDropdown && (
                            <DropdownList>
                                {categories.map((category, index) => {
                                    const option = category.category_name || ""; // adjust key depending on your API
                                    const isSelected = selectedCategories.includes(category.awardId);
                                    return (
                                        <DropdownItem
                                            key={category.awardId}
                                            onClick={() => {
                                                if (!isSelected) {
                                                    setSelectedCategories(prev => [...prev, category.awardId]);
                                                }
                                            }}
                                            disabled={isSelected}
                                            style={{
                                                color: isSelected ? "#aaa" : "#000",
                                                cursor: isSelected ? "not-allowed" : "pointer",
                                                pointerEvents: isSelected ? "none" : "auto",
                                                backgroundColor: isSelected ? "#f9f9f9" : "white"
                                            }}
                                        >
                                            {option}
                                        </DropdownItem>
                                    );
                                })}
                            </DropdownList>
                        )}
                    </div>
                )}

                <div className="section_three_radio">
                    <PaymentPendingHeading>Select Judges</PaymentPendingHeading>
                </div>
                <div className="section_three_check">
                    <RadioOption>
                        <RadioInput
                            type="radio"
                            name="judges"
                            value="All"
                            checked={selectedJudgesCategory === 'All'}
                            onChange={() => {
                                setSelectedJudgesCategory('All');
                                setSelectedJudges(judges.map(j => j.juryAssignId));
                              }}
                        />
                        <span>All</span>
                    </RadioOption>
                    <RadioOption>
                        <RadioInput
                            type="radio"
                            name="judges"
                            value="Custom"
                            checked={selectedJudgesCategory === 'Custom'}
                            onChange={() => {
                                setSelectedJudgesCategory('Custom');
                                setSelectedJudges([]);
                              }}
                        />
                        <span>Custom</span>
                    </RadioOption>
                </div>

                {selectedJudgesCategory === "Custom" && (
                    <div style={{ position: "relative", width: "400px", zIndex: 10 }}>
                        <CustomInput
                            type="text"
                            placeholder="Select custom judge..."
                            onFocus={() => setShowJudgeDropdown(true)}
                            onBlur={() => setTimeout(() => setShowJudgeDropdown(false), 200)}
                        />

                        <SelectedOptionsContainer>
                            {selectedJudges.map((id) => {
                                const judge = judges.find(j => j.juryAssignId === id);
                                return (
                                    <OptionPill key={id}>
                                        {judge?.email || id}
                                        <RemoveIcon
                                            onClick={() =>
                                                setSelectedJudges(prev => prev.filter(jid => jid !== id))
                                            }
                                        >
                                            ×
                                        </RemoveIcon>
                                    </OptionPill>
                                );
                            })}
                        </SelectedOptionsContainer>


                        {showJudgeDropdown && (
                            <DropdownList>
                                {judges.map((judge, index) => {
                                    const isSelected = selectedJudges.includes(judge.juryAssignId);
                                    return (
                                        <DropdownItem
                                            key={judge.juryAssignId}
                                            onClick={() => {
                                                if (!isSelected) {
                                                    setSelectedJudges(prev => [...prev, judge.juryAssignId]);
                                                }
                                            }}
                                            disabled={isSelected}
                                            style={{
                                                color: isSelected ? "#aaa" : "#000",
                                                cursor: isSelected ? "not-allowed" : "pointer",
                                                pointerEvents: isSelected ? "none" : "auto",
                                                backgroundColor: isSelected ? "#f9f9f9" : "white"
                                            }}
                                        >
                                            {judge.email}
                                        </DropdownItem>
                                    );
                                })}
                            </DropdownList>
                        )}
                    </div>
                )}
<div className="section_three_radio">
    <PaymentPendingHeading>Select Top Score</PaymentPendingHeading>
</div>
<div style={{ position: "relative", width: "200px", marginBottom: "20px" }}>
    <CustomInput2
        as="select"
        value={selectedTopScore}
        onChange={(e) => setSelectedTopScore(e.target.value)}
    >
        {["All", 5, 10, 20, 50, 100, 200, 500].map(option => (
            <option key={option} value={option}>
                {option}
            </option>
        ))}
    </CustomInput2>
</div>

                <div className="section_three_btn">
                    <GreyBorderButton onClick={() => setSelectedButton(2)}>
                        Cancel
                    </GreyBorderButton>
                    <RedBackgroundButton onClick={handleNextClick}>
                        Next
                    </RedBackgroundButton>
                </div>
            </div>
        </div>


    );
};



const RadioInput = styled.input`
  margin: 0;
  padding: 0;
`;

const RadioOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 4px; 
  margin-right: 24px; 
`;


const HorizontalOptions = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 8px;
`;
const StyledRoundCheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  max-height: 170px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  -ms-overflow-style: none;
`;
const RoundItem = styled.label`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #f9f9f9;
    font-size: 14px;
    max-width: min-content;
`;


const CustomInput = styled.input`
  padding: 8px 12px;
  width: 400px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const CustomInput2 = styled.input`
  padding: 8px 12px;
  width: 130px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
`;

const DropdownList = styled.div`
  position: absolute;
   list-style: none;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px; // optional scroll
  overflow-y: auto;
  background-color: white;
 border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000; // very important
`;

const DropdownItem = styled.li`
 
  padding: 8px 12px;
  &:hover {
    background-color: #f0f0f0;
  }
`;



const SelectedOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  gap: 8px;
`;

const OptionPill = styled.div`
  display: flex;
  align-items: center;
  background: #e6f4ea;
  color: #256029;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 14px;
`;

const RemoveIcon = styled.span`
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
`;
